import React from 'react';
import css from './Sections.module.css';
import { TalentPlusService } from '../../../util/enums';
import { FormattedMessage } from 'react-intl';
import { Icons, PrimaryButton } from '../../../components';
import classNames from 'classnames';
import { getTalentServiceDescription } from '../../../config/configExtras';

const ContentCreation = ({ talentPlus, title }) => {
  const contentCreation = talentPlus?.filter(
    service => service?.service === TalentPlusService.CONTENT_CREATION
  );

  const availableItems =
    contentCreation?.map(training => ({
      title: training.type === 'Custom' ? training.service : training.type,
      price: training.price,
    })) || [];

  return (
    <>
      <div className={css.getCustomVideo}>
        <h2>
          <FormattedMessage id="EnhancedServices.ContentCreation.modelTitle" />{' '}
          <FormattedMessage id="SectionAppearances.from" values={{ title }} />
        </h2>
      </div>
      {availableItems.length > 0
        ? availableItems.map((item, idx) => (
            <div className={css.bookingSec} key={idx}>
              <div className={classNames(css.offerSec, css.withoutIconSec)}>
                <div className={css.offerContent}>
                  <h2>{item.title}</h2>
                  <p>${Number(item.price).toFixed(2)} per hour</p>
                  <p>{getTalentServiceDescription(item?.title)}</p>
                  <PrimaryButton className={css.bookBtn}>
                    <Icons name="security" />
                    <FormattedMessage id="EnhancedServices.SectionExclusedTraining.buyNowButton" />
                  </PrimaryButton>
                </div>
              </div>
            </div>
          ))
        : null}
    </>
  );
};

export default ContentCreation;
